/**
 * Window-event bridge into the globally mounted ``DownloadQuoteGate``
 * (``HorizontalNavBar``). Callers outside the Configure Deployment flow — the
 * training-complete toast in ``useUpdatesListener`` — dispatch a request here
 * instead of importing modal components, so one modal implementation serves
 * every download entry point.
 */
export const MODEL_DOWNLOAD_REQUEST_EVENT = 'model-download:request';

/**
 * Ask the global gate to quote ``items`` (``[{llm_usecase_id, version, label}]``)
 * and run ``onApproved({ onPaymentRequired })`` once the download is approved.
 * ``onPaymentRequired`` reopens the "Not enough credits" modal from the quote
 * when the download request itself answers 402.
 */
export function requestGatedModelDownload({ items, onApproved }) {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(MODEL_DOWNLOAD_REQUEST_EVENT, { detail: { items, onApproved } }));
}
